import type { ButtonHTMLAttributes } from "react";
import { Spinner } from "../Feedback/Spinner";
import styles from "./Button.module.css";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "primary" | "navy" | "leadcat" | "secondary" | "danger";
  loading?: boolean;
}

export function Button({
  variant = "secondary",
  loading = false,
  disabled,
  className = "",
  children,
  type = "button",
  ...props
}: ButtonProps) {
  return (
    <button
      {...props}
      type={type}
      className={`${styles.button} ${styles[variant]} ${className}`}
      disabled={disabled || loading}
      aria-busy={loading || undefined}
    >
      {loading ? <Spinner size="small" decorative /> : null}
      <span>{children}</span>
    </button>
  );
}
